define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var InlineInputModel = Backbone.Model.extend({
        defaults : {
            value : null,
            caption: '',
            placeholder : '',
            label:'',
            maxLength:50,
            enabled: true
        }
    });

    return InlineInputModel;
});
